import { memo, useState } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { BodyCopy } from "../../../components/BodyCopy";
import {
  AuraLayout,
  Button,
  Layout,
  PageTitle,
} from "lola-framework-ui-test";
import { ErrorAlertIcon as ErrorIcon } from "../../../assets/icons";
import { FlowHeroMark } from "../../../components/FlowHeroMark";
import { SupportSheet } from "../../../components/SupportSheet";
import { useStore } from "../../../store/globalState";
import { ScrollFadeIndicator } from "../../../components/ScrollFadeIndicator";

/**
 * Static maintenance screen for every widget gallery category.
 * No API. Copy is the built-in default. The support button opens the same
 * popup with sample channels and does not leave the screenbook.
 */
export const MaintenanceGalleryPage = memo(() => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const namespace = pathname.split("/").filter(Boolean)[0] || "send";
  const { theme } = useStore();
  const colorConfig = theme.errorView;
  const { backgroundBtn, textColorBtn, title, bodyCopy, iconColors, backgroundIcon } =
    colorConfig;
  const [supportOpen, setSupportOpen] = useState(false);

  return (
    <AuraLayout colorConfig={colorConfig} className="flow-landing-page">
      <Layout.Content className="landing-section flow-hero-section">
        <ScrollFadeIndicator color={colorConfig.bodyCopy} />
        <section className="flow-hero">
          <FlowHeroMark backgroundIcon={backgroundIcon}>
            <ErrorIcon size={60} colors={iconColors} />
          </FlowHeroMark>
          <section className="landing-container">
            <PageTitle
              highlight={t("error.maintenanceTitle", "We're under maintenance")}
              highlightColor={title}
              secudnary=""
              secudnaryColor={title}
            />
            <BodyCopy textColor={bodyCopy}>
              {t(
                "error.maintenanceMessage",
                "The service can't be used right now. Please try again later.",
              )}
            </BodyCopy>
          </section>
        </section>
      </Layout.Content>
      <Layout.Footer>
        <section className="footer-section">
          <Button
            size="large"
            background={backgroundBtn}
            color={textColorBtn}
            onClick={() => setSupportOpen(true)}
          >
            {t("error.contactSupport", "Contact support")}
          </Button>
        </section>
      </Layout.Footer>
      <SupportSheet
        namespace={namespace}
        visible={supportOpen}
        onClose={() => setSupportOpen(false)}
        channels={{
          email: "support@example.com",
          whatsapp: "+15551234567",
        }}
      />
    </AuraLayout>
  );
});
